import axios from "axios";

const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api/categories/`;

// Create category
const createCategory = async (categoryData) => {
    const response = await axios.post(API_URL, categoryData, {
        withCredentials: true
    });
    return response.data;
};

// Get all categories
const getCategories = async (params = {}) => {
    const queryString = new URLSearchParams(params).toString();
    const url = queryString ? `${API_URL}?${queryString}` : API_URL;

    const response = await axios.get(url, {
        withCredentials: true
    });
    return response.data;
};

// Get category by ID
const getCategoryById = async (id) => {
    const response = await axios.get(API_URL + id, {
        withCredentials: true
    });
    return response.data;
};

// Update category
const updateCategory = async (id, categoryData) => {
    const response = await axios.put(API_URL + id, categoryData, {
        withCredentials: true
    });
    return response.data;
};

// Delete category
const deleteCategory = async (id) => {
    const response = await axios.delete(API_URL + id, {
        withCredentials: true
    });
    return response.data;
};

const categoryService = {
    createCategory,
    getCategories,
    getCategoryById,
    updateCategory,
    deleteCategory,
};

export default categoryService;
